import { render, staticRenderFns } from "./TemplateTypeList.vue?vue&type=template&id=01553a5d&scoped=true&"
import script from "./TemplateTypeList.vue?vue&type=script&lang=js&"
export * from "./TemplateTypeList.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTypeList.vue?vue&type=style&index=0&id=01553a5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01553a5d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01553a5d')) {
      api.createRecord('01553a5d', component.options)
    } else {
      api.reload('01553a5d', component.options)
    }
    module.hot.accept("./TemplateTypeList.vue?vue&type=template&id=01553a5d&scoped=true&", function () {
      api.rerender('01553a5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Template/TemplateTypeList.vue"
export default component.exports